import React, { useState } from 'react';
// interfaces
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
// componentes
import Button from '../../atoms/button/button';
import RichtextDescription from '../../atoms/richtext-description/richtextDescription';
import TitleSection from '../../molecules/title-section';
import LikeButtonGroup from '../like-dislike/like-dislike';

// Services //
import { CONTENT_TYPE_ARTICULO } from "../../../services/social.services";
// estilos
import './frecuentQuestionsIndependent.scss'
// Este componente es para las preguntas frecuentes, que son independentes (seccion, seccion)
const FrequentlyAskedQuestionsV2 = (props: ReferenciaContenido) => {

   const [showanswerdes, setquesanswer] = useState(0);
   const changeanswers = (dess: number) => {
      setquesanswer(showanswerdes === dess ? -1 : dess)
   }

   return (
      <div className='m-frequentlyV2'>
         <TitleSection title={props.tituloGeneral} />
         <div className='m-frequentlyV2-questions'>
            {
               props.referenciaPlantillaContenido.map((elem, indexpo) => (
               <div className={`m-questions`} key={ elem.tituloBanner.replace(' ', '') }>
                  <div className={`m-questions-title ${indexpo === showanswerdes ? 'm-questions-title-show' : ''} `}
                     onClick={() => changeanswers(indexpo)}
                  >
                     <h3>{elem.tituloBanner}</h3>
                     <button type='button' onClick={() => changeanswers(indexpo)} aria-label={elem.tituloBanner}>
                        <i className={`m-questions-icon ${indexpo === showanswerdes ? 'icon-minus-thin' : 'icon-plus-thin'}`} />
                     </button>
                  </div>
                  <div className={`m-questions-description`}>
                     <RichtextDescription {...elem.descripcion} />
                     <div className='line'/>
                     <LikeButtonGroup contentId={elem.contentful_id}  utilidad={true} contentType={CONTENT_TYPE_ARTICULO} textoBotones="¿Qué tan útil fue esta información?"/>
                  </div>
               </div>))
            }
         </div>
         {props.tituloBoton && <div className='m-frequentlyV2-button'>
            <Button
               type={"link"}
               classname={`primary`}
               text={props.tituloBoton}
               href={props.redireccionBoton}
               isDisabled={false}
            />
         </div>}
      </div>
   )
}
export default FrequentlyAskedQuestionsV2;